import isDark from '../../../common/verifiers/is-dark';
import increaseOpacity from '../../../common/utils/increase-opacity';

const primary = (params) => {
  const { backgroundColor, whiteColor, blackColor } = params;
  const fallback = {
    rule: 'table.rowLine.primary',
    params,
  };
  if (isDark(backgroundColor)) {
    return increaseOpacity({
      targetColor: whiteColor,
      backgroundColor,
      opacity: 0.01,
      condition: (ratio) => ratio >= 1.5,
      fallback,
    });
  }
  return increaseOpacity({
    targetColor: blackColor,
    backgroundColor,
    opacity: 0.01,
    condition: (ratio) => ratio >= 1.25,
    fallback,
  });
};

export default primary;
